export type DiscountItemLine = {
  id: string
  /** Line id from server after save (for Update). */
  serverLineId?: number
  itemId: string
  batchId: string
  discountPercent: string
}

export function newDiscountItemLine(): DiscountItemLine {
  return {
    id:
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `ln-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    itemId: '',
    batchId: '',
    discountPercent: '',
  }
}
